const landRentalResultsCeil = -10700;

export default landRentalResultsCeil;
